import { getAllStorage } from './storage';

export function trackEvent(eventName, payload, options) {
  if (window.analytics && window.analytics.track) {
    window.analytics.track(eventName, payload, options);
  }
}

export function trackOptimizelyEvent(eventName) {
  window.optimizely = window.optimizely || [];
  window.optimizely.push({
    type: 'event',
    eventName,
  });
}

function mapOnboardingEventsToOptimizelyMetrics(businessUnit, component) {
  // Event names convert to optimizely experiment metrics.
  // Metric names must match the event names exactly.
  // Only fires when certain experiment conditions are met: https://segment.com/docs/destinations/optimizely-web/#track
  if (businessUnit === 'WEDDING_REGISTRY' && component === 'REGISTRY') {
    trackOptimizelyEvent('Onboarding Completed - Registry');
  } else if (businessUnit === 'INVITATIONS' && component === 'SAVE_THE_DATE') {
    trackOptimizelyEvent('Onboarding Completed - STD');
  } else if (businessUnit === 'INVITATIONS' && component === 'INVITATIONS') {
    trackOptimizelyEvent('Onboarding Completed - Invitations');
  } else if (businessUnit === 'WEDDINGS' && component === 'WEDDINGS') {
    trackOptimizelyEvent('Onboarding Completed - Weddings');
  } else if (businessUnit === 'WEDDINGS' && component === 'WEDDING_WEBSITE') {
    trackOptimizelyEvent('Onboarding Completed - Weddings - Component - Website');
  }
}

export function trackUserCreated(email, pkey) {
  const payload = { email, pkey };
  trackEvent('User Created', payload);
}

export function trackOnboardingStarted(businessUnit, component, isExistingUser = null) {
  if (window.analytics && window.dataLayer) {
    window.dataLayer.push({ is_existing_user: isExistingUser });
  }
  const payload = {
    business_unit: businessUnit,
    component
  };
  trackEvent('Onboarding Started', payload);
}

export function trackOnboardingCompleted(businessUnit, component, isExistingUser = null) {
  // Impact Radius should only receive Registry First Onboarding Completed events
  const registryFirst = (businessUnit === 'WEDDING_REGISTRY' && !isExistingUser);
  const clickId = getAllStorage('clickId');
  const options = {
    integrations: {
      'Impact Radius': false
    }
  };
  if (clickId && registryFirst) {
    options.context = {
      referrer: {
        type: 'impactRadius',
        id: clickId
      }
    };
    options.integrations['Impact Radius'] = true;
  }

  if (window.analytics && window.dataLayer) {
    window.dataLayer.push({ is_existing_user: isExistingUser });
  }
  const payload = {
    business_unit: businessUnit,
    component
  };
  mapOnboardingEventsToOptimizelyMetrics(businessUnit, component);
  trackEvent('Onboarding Completed', payload, options);
}

export function trackOnboardingStepCompleted(businessUnit, component, stepKey, stepName, questionnaireVersion) {
  const payload = {
    step_key: stepKey,
    step_name: stepName,
    business_unit: businessUnit,
    component,
    questionnaire_version: questionnaireVersion
  };
  trackEvent('Onboarding Step Completed', payload);
}

// Tracking  Utility Functions - These function use data from the Analytics cache.
// https://github.com/NewAmsterdamLabs/data-infrastructure/blob/development/segment2redis/README.md

export function hasOnboardedForInvitationsProduct(userContext, invitesProjectType) {
  const productsOnboarded = userContext && userContext.analytics && userContext.analytics.products_onboarded;
  if (!productsOnboarded || !invitesProjectType) {
    return false;
  }
  return productsOnboarded.filter(product => product.component === invitesProjectType).length > 0;
}

export function hasPreviousDraftsForProjectType(drafts, invitesProjectType) {
  if (drafts.length > 0) {
    return drafts.filter(draft => draft.primary_customization.type === invitesProjectType).length > 0;
  }
  return false;
}

export function userCreatedAfter(testBeganAtStr) {
  const testBeganAt = (new Date(testBeganAtStr)).getTime();
  const userCreatedAtValue = getAllStorage('zolaUserCreatedAt');
  const userCreatedAfterTestBegan = userCreatedAtValue ? (new Date(userCreatedAtValue)).getTime() > testBeganAt : false;
  return userCreatedAfterTestBegan;
}

export function hasOnboardedForProduct(userContext, businessUnitComponent) {
  const productsOnboarded = userContext && userContext.analytics && userContext.analytics.products_onboarded;
  if (!productsOnboarded) {
    return false;
  }
  return productsOnboarded.filter(product => product.component === businessUnitComponent).length > 0;
}



// WEBPACK FOOTER //
// ./src/util/trackingHelper.js